export default "__VITE_ASSET__cef1e2dc__"